import React, { useState, useEffect } from "react"

import {
  InstantSearch,
  ToggleRefinement
} from "react-instantsearch-dom"

function IncludeSold(props) {
  return (
    <InstantSearch
      indexName={props.indexName}
      searchClient={props.searchClient}
      searchState={props.searchState}
      onSearchStateChange={props.onSearchStateChange}
      createURL={props.createURL}
      routing="true"
    >
      {props.ptype === "sales" ?
        <div className="switch-button ">
        <label for="toggle-button">
          <input
            type="checkbox"
            id="toggle-button"
            onChange={props.includeSoldclick}
            checked={props.includeSoldinside ? "checked" : ""}
          />
          <span className="toggle-switch">
            <span className="toggle-switch-bar"></span>
          </span>
          <span className="toggle-text">Include Sold</span>
        </label>
      </div> :
         <div className="switch-button ">
         <label for="toggle-button">
           <input
             type="checkbox"
             id="toggle-button"
             onChange={props.includeLetclick}
             checked={props.includeLetinside ? "checked" : ""}
           />
           <span className="toggle-switch">
             <span className="toggle-switch-bar"></span>
           </span>
           <span className="toggle-text">Include Let</span>
         </label>
       </div>
      }

    </InstantSearch>
  )
}
export default IncludeSold